import defineActionTypes from 'helpers/defineActionTypes';

// Define action types
export default defineActionTypes('fields', ['GET_FIELDS_START', 'GET_FIELDS_SUCCESS']);



// WEBPACK FOOTER //
// state/add/types.js